var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContentLeftAlign = function SvgContentLeftAlign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C8 3.55228 7.55229 4 7 4H1C0.447718 4 2.86102e-06 3.55228 2.86102e-06 3C2.86102e-06 2.44772 0.447718 2 1 2H7C7.55229 2 8 2.44772 8 3ZM11 9C11.5523 9 12 8.55228 12 8C12 7.44772 11.5523 7 11 7H1C0.447715 7 2.38419e-07 7.44772 2.38419e-07 8C2.38419e-07 8.55228 0.447715 9 1 9H11ZM0.999992 14H15C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12H0.999992C0.447708 12 -7.62939e-06 12.4477 -7.62939e-06 13C-7.62939e-06 13.5523 0.447708 14 0.999992 14Z"
  })));
};
export default SvgContentLeftAlign;